// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"120":"Contacts","308":"Video","596":"PixelArt","653":"Design","685":"Motion","692":"Dev","810":"NotFound"}[chunkId] + "." + {"120":"34b6301f","308":"8f729aaf","596":"0e6682ce","653":"d1a74b35","685":"2fb90fd7","692":"72a11efe","810":"87b6df14"}[chunkId] + ".chunk.css";
};